import { apiFetch } from "../utils/api";
import { getAdminHeaders } from "../pages/admin/adminApi";

const BASE = "/api/book-club/co-read";

async function parse(res) {
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const detail = data.detail;
    throw new Error(
      typeof detail === "string" ? detail : detail?.[0]?.msg || data.message || "请求失败"
    );
  }
  return data;
}

export function coReadGet(path) {
  return apiFetch(`${BASE}${path}`).then(parse);
}

export function coReadPost(path, body) {
  return apiFetch(`${BASE}${path}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  }).then(parse);
}

export async function adminCoReadGet(path) {
  const res = await fetch(`${BASE}${path}`, { headers: getAdminHeaders() });
  return parse(res);
}

export async function adminCoReadPost(path, body) {
  const res = await fetch(`${BASE}${path}`, {
    method: "POST",
    headers: getAdminHeaders(true),
    body: JSON.stringify(body),
  });
  return parse(res);
}

export async function adminCoReadDelete(path) {
  const res = await fetch(`${BASE}${path}`, {
    method: "DELETE",
    headers: getAdminHeaders(),
  });
  return parse(res);
}

export async function adminCoReadUpload(readingId, file) {
  const form = new FormData();
  form.append("reading_id", String(readingId));
  form.append("file", file);
  const res = await fetch(`${BASE}/admin/upload`, {
    method: "POST",
    headers: getAdminHeaders(),
    body: form,
  });
  return parse(res);
}

/** 将值日周同步到共读中心集体计划 */
export function adminSyncDutyWeek(dutyWeekId) {
  return adminCoReadPost("/admin/sync-duty-week", {
    duty_week_id: Number(dutyWeekId),
    operator: "admin",
  });
}

export function adminDutySyncStatus(dutyWeekIds) {
  const ids = (dutyWeekIds || []).filter(Boolean).join(",");
  return adminCoReadGet(
    `/admin/duty-sync-status?duty_week_ids=${encodeURIComponent(ids)}`
  );
}
